import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar fixed-top navbar-expand-lg navbar-dark bg-dark sticky" }
const _hoisted_2 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_3 = { class: "navbar-nav" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_navbar_link = _resolveComponent("navbar-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "nav-link navbar-brand",
      "active-class": "custom-active",
      to: "/"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" Brain Twist ", -1)
      ]))]),
      _: 1
    }),
    _cache[1] || (_cache[1] = _createElementVNode("button", {
      class: "navbar-toggler",
      type: "button",
      "data-bs-toggle": "collapse",
      "data-bs-target": "#navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }, [
      _createElementVNode("span", { class: "navbar-toggler-icon" })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createVNode(_component_navbar_link, {
          name: "Home",
          to: ""
        }),
        _createVNode(_component_navbar_link, {
          name: "Privacy policy",
          to: "privacy-policy"
        }),
        _createVNode(_component_navbar_link, {
          name: "Terms of service",
          to: "terms-of-service"
        }),
        _createVNode(_component_navbar_link, {
          name: "Account Deletion",
          to: "delete-account"
        }),
        _createVNode(_component_navbar_link, { name: "Contact" })
      ])
    ])
  ]))
}